import React from 'react';
import { toast } from 'react-toastify';

const Toaster = ({ errorMessage }) => {
  return (
    <div>
      {toast.error(
        { errorMessage },
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        },
      )}
    </div>
  );
};

export default Toaster;
